import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import History from "../views/History.vue";
import Users from "../views/Users";
import Clients from "../views/Clients";
import Workgroups from "../views/Workgroups";
import Schedules from "../views/Schedules";
import ClientsWorkgroups from "../views/ClientsWorkgroups";

Vue.use(VueRouter);

const userAuth = localStorage.getItem("userAuth")
  ? JSON.parse(localStorage.getItem("userAuth"))
  : null;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/falcon/history",
      name: "History",
      component: History,
      meta: { requiresAuth: true }
    },
    {
      path: "/falcon/users",
      name: "Users",
      component: Users,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (userAuth.isAdmin) {
          next();
        } else {
          next({ name: "Home" });
        }
      }
    },
    {
      path: "/falcon/clients",
      name: "Clients",
      component: Clients,
      meta: { requiresAuth: true }
    },
    {
      path: "/falcon/groups",
      name: "Workgroups",
      component: Workgroups,
      meta: { requiresAuth: true }
    },
    {
      path: "/falcon/schedules",
      name: "Schedules",
      component: Schedules,
      meta: { requiresAuth: true }
    },
    {
      path: "/falcon/clients-groups",
      name: "ClientsWorkgroups",
      component: ClientsWorkgroups,
      meta: { requiresAuth: true }
    },
    {
      path: "/falcon",
      name: "Home",
      component: Home,
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //need to login
    if (!userAuth) {
      window.location.replace("/login.html");
      // next({ name: "NoFound" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
